import { createFileRoute } from "@tanstack/react-router";
import { PolicyLayout, PolicySection } from "@/components/skl/PolicyLayout";

export const Route = createFileRoute("/handelsbetingelser")({
  head: () => ({
    meta: [
      { title: "Handelsbetingelser — SKL-Flow" },
      { name: "description", content: "Handelsbetingelser for levering af digitale hjemmeside-ydelser fra SKL-Flow." },
      { name: "robots", content: "index,follow" },
      { property: "og:title", content: "Handelsbetingelser — SKL-Flow" },
      { property: "og:description", content: "Vilkår for aftaler indgået med SKL-Flow om levering af digitale produkter og hjemmeside-ydelser." },
      { property: "og:type", content: "article" },
    ],
    links: [{ rel: "canonical", href: "https://sklflow.com/handelsbetingelser" }],
  }),
  component: Handelsbetingelser,
});

function Handelsbetingelser() {
  return (
    <PolicyLayout title="Handelsbetingelser" updated="5. juli 2026">
      <PolicySection title="1. Generelle oplysninger">
        <p>
          Disse handelsbetingelser (herefter “Betingelserne”) gælder for enhver aftale, der indgås mellem
          kunden (herefter “Kunden”) og SKL-Flow (herefter “Leverandøren”) om levering af digitale
          produkter, herunder hjemmesider, hjemmeside-udkast og relaterede digitale ydelser.
        </p>
        <p>
          Leverandørens kontaktoplysninger:
          <br />
          SKL-Flow
          <br />
          E-mail: emilsklanderandersen@gmail.com
          <br />
          Web: sklflow.com
        </p>
        <p>
          SKL-Flow er en enkeltmandsvirksomhed uden CVR-registrering. Ved erhvervsdrivende
          registrering vil CVR-nummer blive tilføjet her.
        </p>
      </PolicySection>

      <PolicySection title="2. Aftalens indgåelse">
        <p>
          En aftale anses for indgået, når Kunden har accepteret et fremsendt tilbud, udkast eller
          skriftlig bekræftelse fra Leverandøren, herunder via e-mail eller ved godkendelse af leveret
          udkast. Leverandøren forbeholder sig retten til at afvise henvendelser uden begrundelse.
        </p>
        <p>
          Betingelserne udgør sammen med det konkrete tilbud det samlede aftalegrundlag. Ved eventuel
          uoverensstemmelse går det individuelle tilbud forud for disse Betingelser.
        </p>
      </PolicySection>

      <PolicySection title="3. Ydelsens omfang">
        <p>
          Leverandøren udarbejder et uforpligtende hjemmeside-udkast, som Kunden gennemgår.
          Kunden er alene forpligtet til at betale, såfremt udkastet godkendes, og der efterfølgende
          indgås aftale om færdiggørelse, drift eller yderligere ydelser.
        </p>
        <p>
          Omfang, funktioner, indhold, deadlines og priser for eventuelle tilkøb aftales skriftligt inden
          arbejdet påbegyndes. Ændringer i omfang efter aftaleindgåelse kan medføre justering af pris
          og leveringstid.
        </p>
      </PolicySection>

      <PolicySection title="4. Priser og betaling">
        <p>
          Alle priser er angivet i danske kroner (DKK). Da Leverandøren p.t. ikke er momsregistreret,
          tillægges der ikke moms. Såfremt Leverandøren bliver momsregistreret, oplyses momspligtige
          priser tydeligt i tilbud.
        </p>
        <p>
          Betaling forfalder som udgangspunkt 8 dage efter fakturadato, medmindre andet er aftalt
          skriftligt. Ved forsinket betaling påløber morarenter i henhold til rentelovens bestemmelser
          samt eventuelle rykkergebyrer i henhold til gældende lovgivning.
        </p>
      </PolicySection>

      <PolicySection title="5. Levering">
        <p>
          Digitale produkter leveres elektronisk. Et indledende udkast leveres normalt inden for 24 timer
          efter modtagelse af nødvendige oplysninger fra Kunden. Endelig levering af den samlede
          løsning sker efter individuel aftale.
        </p>
        <p>
          Leverandøren tilstræber overholdelse af aftalte leveringstider, men er ikke ansvarlig for
          forsinkelser, der skyldes forhold uden for Leverandørens kontrol, herunder Kundens
          manglende bidrag med indhold, godkendelser eller oplysninger.
        </p>
      </PolicySection>

      <PolicySection title="6. Fortrydelsesret for forbrugere">
        <p>
          Ved aftaler indgået med forbrugere gælder en 14 dages fortrydelsesret i henhold til
          forbrugeraftaleloven, regnet fra aftalens indgåelse.
        </p>
        <p>
          Da Leverandøren leverer digitalt indhold, som ikke leveres på et fysisk medium, samtykker
          Kunden ved bestilling udtrykkeligt til, at levering påbegyndes inden fortrydelsesfristens udløb,
          og anerkender, at fortrydelsesretten dermed bortfalder, når levering er påbegyndt, jf.
          forbrugeraftalelovens § 18, stk. 2, nr. 13.
        </p>
        <p>
          Erhvervsdrivende (B2B) har ikke fortrydelsesret, medmindre andet er aftalt skriftligt.
        </p>
      </PolicySection>

      <PolicySection title="7. Reklamation og mangler">
        <p>
          Forbrugere har 24 måneders reklamationsret i henhold til købelovens regler for mangler ved
          det leverede digitale produkt, forudsat at manglen ikke skyldes Kundens egne forhold,
          forkert brug eller ændringer foretaget af tredjepart.
        </p>
        <p>
          Reklamation skal ske inden for rimelig tid efter, at Kunden har opdaget eller burde have
          opdaget manglen. Reklamation kan rettes til emilsklanderandersen@gmail.com.
        </p>
      </PolicySection>

      <PolicySection title="8. Immaterielle rettigheder">
        <p>
          Ophavsret og øvrige immaterielle rettigheder til leverede designs, kode, tekster og øvrige
          digitale værker tilhører Leverandøren, indtil fuld betaling er modtaget. Ved fuld betaling
          overdrages en tidsubegrænset, ikke-eksklusiv brugsret til Kunden til brug for det aftalte
          formål.
        </p>
        <p>
          Leverandøren bevarer retten til at anvende det leverede som referencemateriale i eget
          markedsføringsmateriale, medmindre andet er skriftligt aftalt.
        </p>
      </PolicySection>

      <PolicySection title="9. Ansvarsbegrænsning">
        <p>
          Leverandøren er alene ansvarlig for direkte tab som følge af egne dokumenterede fejl.
          Leverandørens samlede ansvar kan ikke overstige det beløb, Kunden har betalt for den
          konkrete ydelse i en periode på 12 måneder forud for kravets opståen.
        </p>
        <p>
          Leverandøren er ikke ansvarlig for indirekte tab, driftstab, tab af data, tabt fortjeneste eller
          følgeskader. Leverandøren er ikke ansvarlig for nedetid, fejl eller sikkerhedsbrud hos
          tredjepartsudbydere (fx hosting, betalingsudbydere eller e-mailtjenester).
        </p>
      </PolicySection>

      <PolicySection title="10. Force majeure">
        <p>
          Leverandøren er ikke ansvarlig for manglende opfyldelse af sine forpligtelser, når dette
          skyldes forhold uden for Leverandørens kontrol, herunder men ikke begrænset til
          strømafbrydelser, netværksnedbrud, cyberangreb, arbejdsnedlæggelser, myndighedspåbud
          eller naturkatastrofer.
        </p>
      </PolicySection>

      <PolicySection title="11. Persondata">
        <p>
          Behandling af personoplysninger sker i overensstemmelse med Leverandørens
          <a href="/privatlivspolitik" className="underline hover:no-underline"> privatlivspolitik</a>.
        </p>
      </PolicySection>

      <PolicySection title="12. Ændringer">
        <p>
          Leverandøren forbeholder sig retten til at ændre disse Betingelser. Den til enhver tid
          gældende version er tilgængelig på sklflow.com/handelsbetingelser. Væsentlige ændringer
          varsles med rimeligt varsel over for eksisterende kunder.
        </p>
      </PolicySection>

      <PolicySection title="13. Klageadgang">
        <p>
          Klager over Leverandørens ydelser kan indbringes for Center for Klageløsning,
          Nævnenes Hus, Toldboden 2, 8800 Viborg (www.forbrug.dk). Forbrugere bosiddende i EU kan
          desuden anvende EU-Kommissionens online klageportal (ODR-platform):{" "}
          <a href="https://ec.europa.eu/consumers/odr" className="underline hover:no-underline">
            ec.europa.eu/consumers/odr
          </a>.
        </p>
      </PolicySection>

      <PolicySection title="14. Lovvalg og værneting">
        <p>
          Enhver tvist mellem parterne afgøres efter dansk ret med Retten i Kundens hjemting som
          første instans, når Kunden er forbruger. For erhvervskunder er værnetinget Retten i det
          retsdistrikt, hvor Leverandøren har hjemsted.
        </p>
      </PolicySection>
    </PolicyLayout>
  );
}
